export default function getYears() {
  const currentYear = new Date().getFullYear()
  return Array.from({ length: 6 }, (_, i) => currentYear - i)
}



// WEBPACK FOOTER //
// ./src/composables/useYears.js